import { Component, inject, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService, SignalRService, SessionTimeoutComponent } from 'shared-library';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SessionTimeoutComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements  OnDestroy {

  logoCRUrl: string = '';

  authService = inject(AuthService);
  private signalRService = inject(SignalRService);

  setFavicon(iconUrl: string) {
    const link: HTMLLinkElement =
      document.querySelector("link[rel~='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = iconUrl;
    document.head.appendChild(link);
  }

  ngOnDestroy(): void {
    this.signalRService.destroyConnection();
  }

  continueSession(): void {
    this.authService.refreshToken().subscribe();
  }
}